import React from "react";
import { Box } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import LandingBackground from "../../components/Landing/LandingBackground";
import Sidebar from "../../components/Sidebar";
import { handleNavigate } from "../../utils/navigateUtils";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/firebase";

const TutorLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <Box sx={{ position: "relative", height: "100vh", overflow: "hidden" }}>
      <LandingBackground />

      <Box
        sx={{
          display: "flex",
          position: "relative",
          zIndex: 2,
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Sidebar
          role="tutor"
          onNavigate={(key) => handleNavigate(key, navigate, "tutor")}
          onLogout={handleLogout}
        />

        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            p: 4,
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default TutorLayout;
